import { useTypedRouteLoaderData } from 'remix-typedjson';
import { type loader as layoutLoader } from '#speaker-shop/routes/_index+/($voice).($lang)+/_layout';
import { type getVoicePageData } from '#speaker-shop/models/voice-page-data.server';
import { type loader as rootLoader } from '#speaker-shop/root';

type VoicePageData = Awaited<ReturnType<typeof getVoicePageData>> & {
    locale: string;
    baseUrl: string;
};

/**
 * Returns layout loader data narrowed to the voice page branch.
 * Only safe to call from components rendered inside <Outlet> (not on the landing page
 * or the unified single-page shop).
 */
export function useVoicePageRootData(): VoicePageData {
    const rootData = useTypedRouteLoaderData<typeof rootLoader>('root')!;
    const layoutData = useTypedRouteLoaderData<typeof layoutLoader>('routes/_index+/($voice).($lang)+/_layout')!;
    if (!('portraitImageSrc' in layoutData)) {
        throw new Error('useVoicePageRootData called outside the voice page');
    }
    return { ...rootData, ...layoutData } as unknown as VoicePageData;
}
